import { render, staticRenderFns } from "./VyIcon.vue?vue&type=template&id=53285b04&scoped=true&"
import script from "./VyIcon.vue?vue&type=script&lang=js&"
export * from "./VyIcon.vue?vue&type=script&lang=js&"
import style0 from "./VyIcon.vue?vue&type=style&index=0&id=53285b04&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53285b04",
  null
  
)

export default component.exports